import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from 'src/redux/store';
import axios from 'src/utils/axios';

const initialState = {
    isAttachmentLoading: false,
    error: null,
    attachment: null,
};

const slice = createSlice({
    name: 'attachment',
    initialState,
    reducers: {
        // START LOADING
        startAttachmentLoading(state) {
            state.isAttachmentLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isAttachmentLoading = false;
            state.isPlanLoading = false;
            state.error = action.payload;
        },
        // SET DATA
        setAttachment(state, action) {
            state.isAttachmentLoading = false;
            state.attachment = action.payload;
        },
    },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    startAttachmentLoading,
    hasError,
} = slice.actions;

// ----------------------------------------------------------------------

export function getAttachment() {
    return async () => {
        dispatch(slice.actions.startAttachmentLoading());
        try {
            const response = await axios.get(`/dropdown/company/attachment/attachments`);
            dispatch(slice.actions.setAttachment(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}